import type { ConfirmAction, LandingPolicy } from '../api/types'

/**
 * The array `board/projects.rs:policy_action` hashes, with every field in
 * order. Later settings are appended only when they differ from their
 * default, in this order: a scope other than full (Poulpe-685), then
 * `'person'` when a person reviews (Poulpe-688).
 */
export function policyJson(project: string, policy: LandingPolicy): string {
  return JSON.stringify([
    project, policy.version,
    policy.reviewer ? [policy.reviewer.agent, policy.reviewer.model] : null,
    policy.cross_vendor_review, policy.person_paths, policy.check_paths,
    policy.checks_need_person,
    policy.max_batch_wait ? [policy.max_batch_wait.secs, policy.max_batch_wait.nanos] : null,
    ...(policy.check_scope && policy.check_scope !== 'full' ? [policy.check_scope] : []),
    ...(policy.review === 'person' ? ['person'] : []),
  ])
}

export async function policyAction(project: string, policy: LandingPolicy): Promise<ConfirmAction> {
  const bytes = new TextEncoder().encode(policyJson(project, policy))
  const digest = new Uint8Array(await crypto.subtle.digest('SHA-256', bytes))
  return { kind: 'set_project_policy', digest: [...digest].map(byte => byte.toString(16).padStart(2, '0')).join('') }
}
